import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import type { IFileBasedExamAttemptResponse } from "@api/courses/exams/fileBased/attempts/types";

const postApis = createPostApi<
  IApiResponse<IFileBasedExamAttemptResponse>,
  IPathBaseParam,
  undefined
>("courses.exams.fileBased.attempt.finish");

export const finish = {
  ...postApis,
};
